import { render, staticRenderFns } from "./editHeader.vue?vue&type=template&id=377c5034&scoped=true&"
import script from "./editHeader.vue?vue&type=script&lang=js&"
export * from "./editHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "377c5034",
  null
  
)

export default component.exports